<script>
    import { navigate } from "svelte-routing";
    export let prompt = 'Enter your mobile number to login';
    let phoneNumber;

    function login() {
      fetch(`/api/v1/login`, {
        body: JSON.stringify({
            phoneNumber,
        }),
        method: 'POST',
      })
      .then(res => {
        navigate(`/login-confirm?phoneNumber=${phoneNumber}`)
      })
    }
</script>

<main>
    <h3 class="center">{prompt}</h3>
    <div class="center">
        <form id="login-form">
            <input bind:value={phoneNumber} class="input" type="text" name="PHONENUMBER" autocomplete="off" placeholder="Enter Mobile Number" data-required="true" required />
            <button on:click|preventDefault={login} type="submit" form="login-form" class="primary">
                Let's Go    
            </button>
        </form>
    </div>
</main>

<style>
    .center {
        text-align: center;
        color: #777;
    }
    button.primary {
        background: green;
        cursor: pointer;
        color: white;
    }
</style>